import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './RegisterBtn.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonCirclePlus, faSignIn } from '@fortawesome/free-solid-svg-icons';

const RegisterBtn = () => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return (
    <>
      <button 
        className="register-floating-btn" 
        onClick={handleShow}
      >
        <FontAwesomeIcon icon={faPersonCirclePlus} className='md:mr-2'/>
        <span className="hidden md:inline">Mon Compte</span>
      </button>

      <Modal 
        show={showModal} 
        onHide={handleClose}
        centered
        contentClassName="bg-transparent border-0 shadow-none"
      >
        <div className="relative overflow-hidden bg-white rounded-[2rem] shadow-2xl border border-gray-100">
          {/* Top Decorative Header */}
          <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 rounded-t-[2rem] overflow-hidden">
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-white opacity-10 rounded-full blur-2xl"></div>
            <div className="absolute top-6 -left-10 w-32 h-32 bg-white opacity-10 rounded-full blur-xl"></div>
          </div>
          
          <button 
            onClick={handleClose}
            className="absolute top-4 right-4 z-20 p-2 text-white/80 hover:text-white bg-black/10 hover:bg-black/20 rounded-full transition-all focus:outline-none"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          </button>

          <Modal.Body className="p-8 pt-12 relative z-10 mt-8 text-center bg-transparent">
            <div className="w-24 h-24 mx-auto bg-white rounded-full flex items-center justify-center p-2 shadow-xl mb-6 border-4 border-indigo-50 relative z-10">
              <div className="w-full h-full bg-indigo-50 rounded-full flex items-center justify-center text-indigo-600">
                <FontAwesomeIcon icon={faPersonCirclePlus} className="text-4xl text-indigo-600" />
              </div>
            </div>

            <h3 className="text-3xl font-extrabold text-gray-800 mb-2">Bienvenue</h3>
            <p className="text-gray-500 mb-8 max-w-sm mx-auto text-sm">Veuillez choisir une option pour accéder à votre espace personnel.</p>

            <div className="flex flex-col gap-4">
              <a 
                href="https://client.youthfp.cm/login" 
                target="_blank" 
                rel="noreferrer"
                className="group relative flex items-center justify-between p-4 bg-white border border-gray-200 rounded-2xl hover:border-indigo-500 hover:shadow-xl hover:shadow-indigo-100 transition-all duration-300 overflow-hidden text-left no-underline"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-indigo-50 to-blue-50 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                
                <div className="relative z-10 flex items-center gap-4">
                  <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-full flex items-center justify-center group-hover:bg-indigo-100 transition-colors text-xl">
                    <FontAwesomeIcon icon={faSignIn} />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 group-hover:text-indigo-700 transition-colors m-0 text-lg">Se Connecter</h4>
                    <p className="text-sm text-gray-500 m-0 mt-1">J'ai déjà un compte</p>
                  </div>
                </div>
                <div className="relative z-10 w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-indigo-100 group-hover:text-indigo-600 transition-all">
                  <FontAwesomeIcon icon={faSignIn} className="text-gray-400 group-hover:text-indigo-600 transform group-hover:translate-x-1 transition-transform" />
                </div>
              </a>

              <a 
                href="/register" 
                className="group relative flex items-center justify-between p-4 bg-white border border-gray-200 rounded-2xl hover:border-purple-500 hover:shadow-xl hover:shadow-purple-100 transition-all duration-300 overflow-hidden text-left no-underline"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-purple-50 to-pink-50 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                
                <div className="relative z-10 flex items-center gap-4">
                  <div className="w-12 h-12 bg-purple-50 text-purple-600 rounded-full flex items-center justify-center group-hover:bg-purple-100 transition-colors text-xl">
                    <FontAwesomeIcon icon={faPersonCirclePlus} />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 group-hover:text-purple-700 transition-colors m-0 text-lg">Créer un compte</h4>
                    <p className="text-sm text-gray-500 m-0 mt-1">Je suis nouveau</p>
                  </div>
                </div>
                <div className="relative z-10 w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-purple-100 group-hover:text-purple-600 transition-all">
                  <FontAwesomeIcon icon={faPersonCirclePlus} className="text-gray-400 group-hover:text-purple-600 transform group-hover:translate-x-1 transition-transform" />
                </div>
              </a>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default RegisterBtn;